export default __webpack_public_path__ + "static/media/farwestfungi_texture.f3ac1344.jpg";